import React, { RefObject } from 'react';
import Link from '../../lib/router/Link';
import router from '../../lib/router/router';

function getEpisodeRoutePath(id: string, slug: string): string {
  return `/episode/${id}/${slug}`;
}

function navigateToEpisodePage(id: string, slug: string) {
  router.pushState(getEpisodeRoutePath(id, slug));
}

function EpisodeLink({
  id,
  slug,
  onClick,
  className,
  dataHook,
  linkRef,
  children,
}: {
  id: string;
  slug: string;
  onClick: VoidFunction;
  linkRef?: RefObject<HTMLAnchorElement>;
  className?: string;
  dataHook?: string;
  children: React.ReactNode;
}) {
  return (
    <Link
      href={getEpisodeRoutePath(id, slug)}
      className={className}
      dataHook={dataHook}
      onClick={onClick}
      linkRef={linkRef}
    >
      {children}
    </Link>
  );
}

export { getEpisodeRoutePath, navigateToEpisodePage };

export default EpisodeLink;
